import { styled } from '@linaria/react';
import { colors, fonts, semantic, space, textStyle } from '../../theme/tokens';

export const Wrapper = styled.div`
  border-top: 1px solid ${semantic.border.default};
  border-bottom: 1px solid ${semantic.border.default};
`;

export const Header = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${space['space-600']} 0;
  background: none;
  border: none;
  cursor: pointer;
  font-family: ${textStyle.body.lg.strong.fontFamily};
  font-size: ${textStyle.body.lg.strong.fontSize};
  font-weight: ${textStyle.body.lg.strong.fontWeight};
  line-height: ${textStyle.body.lg.strong.lineHeight};
  letter-spacing: ${textStyle.body.lg.strong.letterSpacing};
  color: ${semantic.text.primary};
  text-align: left;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const Label = styled.span`
  flex: 1;
`;

export const ChevronIcon = styled.svg<{ $isOpen: boolean }>`
  flex-shrink: 0;
  margin-left: ${space['space-300']};
  transition: transform 0.25s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(90deg)' : 'rotate(0deg)')};
`;

export const ContentOuter = styled.div<{ $isOpen: boolean }>`
  display: grid;
  grid-template-rows: ${({ $isOpen }) => ($isOpen ? '1fr' : '0fr')};
  transition: grid-template-rows 0.25s ease;
`;

export const ContentInner = styled.div<{ $isOpen: boolean }>`
  overflow: hidden;
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
`;

export const ContentPadding = styled.div`
  padding: ${space['space-400']} 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  color: ${semantic.text.secondary};
`;
